import { render, staticRenderFns } from "./CarePlanNew.vue?vue&type=template&id=5fbf8f40&scoped=true"
import script from "./CarePlanNew.vue?vue&type=script&lang=ts"
export * from "./CarePlanNew.vue?vue&type=script&lang=ts"
import style0 from "./CarePlanNew.vue?vue&type=style&index=0&id=5fbf8f40&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf8f40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbf8f40')) {
      api.createRecord('5fbf8f40', component.options)
    } else {
      api.reload('5fbf8f40', component.options)
    }
    module.hot.accept("./CarePlanNew.vue?vue&type=template&id=5fbf8f40&scoped=true", function () {
      api.rerender('5fbf8f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanNew.vue"
export default component.exports